<template>
    <ubi-page-container>
        <ubi-panel>
            <ubi-card-container  :data="produits">
                <template
                        v-slot="{
                      row: {
                          id,
                        titre,
                        courtDescriptif,
                        image,
                        detail,
                        univers
                      }
                    }"
                >
                    <ubi-card
                            class="PostsList-item PostItem"
                            v-if="universValid(univers)"
                    >
                        <template v-slot:header>
                            <el-row>
                                <el-col :span="24">
                                    <router-link :to="{ name: 'details_produit', params: { idProduit: id }}" class="textTitreProduitLien"><h3>{{ titre }}</h3></router-link>
                                </el-col>
                            </el-row>
                        </template>
                        <router-link :to="{ name: 'details_produit', params: { idProduit: id }}"><div v-if="image != null" class="imageProduitsUbiflow" ><img :alt="titre":src="require('@/assets/' + image)" height="350"/></div>
                        <div class="text-center" v-else>
                            <ubi-icon class="no-photo" name="camera" size='350'/>
                        </div></router-link>
                        <el-row class="blockIntroductionProduit">
                            <el-col :span="24">
                                <div class="text-center"><strong>{{ courtDescriptif }}</strong></div>
                            </el-col>
                        </el-row>
                        <el-row class="blockDetailProduit">
                            <el-col :span="24">
                                <div class="text-center">
                                    <el-button type="danger" @click="handleClick(image)">{{ detail }}</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </ubi-card>
                </template>
            </ubi-card-container>
        </ubi-panel>
    </ubi-page-container>
</template>

<script>
import UbiPanel from '../../components/Panel'
import { HTTP_HYPER_ESPACE_BACKEND } from "@/services/http-common";

const axios = require('axios')

export default {
  name: 'Produits',
  components: { UbiPanel },
  data () {
    return {
      produits: []
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  mounted () {
    this.chargerProduits()
  },
  methods: {
    /**
             * On charge la liste de produit
             **/
    async chargerProduits () {
      return HTTP_HYPER_ESPACE_BACKEND
        .get('/produits')
        .then(response => {
          this.produits = response.data
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    handleClick (code) {
      if (this.$ga) {
        const libelle = 'decouvrir_' + code.replace('.png', '')
        this.$ga.event('produits', 'clic', libelle, this.sitimmoUser.id)
      }
      window.open('https://www.ubiflow.net', '_blank')
    },
    universValid (univers) {
      if (univers.includes('IMMO') && this.sitimmoUser.univers === 'IMMO') {
        return true
      }
      if (univers.includes('VO') && this.sitimmoUser.univers === 'VO') {
        return true
      }
      return false
    }
  }
}
</script>

<style>
    .blockIntroductionProduit {
        margin-top: 10px;
        height: 15px;
    }

    .blockDetailProduit {
        margin-top: 20px;
    }

    .textTitreProduitLien{
        text-decoration: none;
    }

    .imageProduitsUbiflow{
        width: 100%;
        padding-left: 55px;
    }
</style>
